import styled from 'styled-components';

export const OuterWrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.24px;
  line-height: 16px;
`;

export const Wrapper = styled.div<{ isLeft: boolean }>`
  position: relative;
  border-radius: 16px;
  height: 24px;
  width: 48px;
  background-color: ${({ isLeft }) =>
    isLeft ? 'var(--colorBlueGray300)' : 'var(--colorBlueGray1200)'};
  transition: background-color 0.2s ease-in-out;
  cursor: pointer;

  &:focus {
    outline-color: var(--colorBlueGray1200);
  }
`;

export const ToggleBall = styled.div<{ isLeft: boolean }>`
  box-shadow: 0px 2px 0px 0px rgb(0 0 0 / 16%), 0px 0px 4px 0px rgb(0 0 0 / 16%);
  height: 20px;
  width: 20px;
  background-color: var(--colorWhite);
  border-radius: 50%;
  top: 2px;
  left: 2px;
  position: absolute;
  transform: ${({ isLeft }) => (isLeft ? 'translateX(0)' : 'translateX(24px)')};
  transition: transform 0.2s ease-in-out;
`;

export const StorybookWrapper = styled.div`
  width: 200px;
`;
